/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 *
 * @export
 * @interface ShopForMeItem
 */
export interface ShopForMeItem {
  /**
   *
   * @type {number}
   * @memberof ShopForMeItem
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof ShopForMeItem
   */
  requestId?: number;
  /**
   *
   * @type {string}
   * @memberof ShopForMeItem
   */
  productUrl?: string;
  /**
   *
   * @type {string}
   * @memberof ShopForMeItem
   */
  productName?: string;
  /**
   *
   * @type {string}
   * @memberof ShopForMeItem
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof ShopForMeItem
   */
  quantity?: number;
  /**
   *
   * @type {number}
   * @memberof ShopForMeItem
   */
  estimatedPrice?: number;
  /**
   *
   * @type {number}
   * @memberof ShopForMeItem
   */
  actualPrice?: number;
  /**
   *
   * @type {string}
   * @memberof ShopForMeItem
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof ShopForMeItem
   */
  imageUrl?: string;
  /**
   *
   * @type {string}
   * @memberof ShopForMeItem
   */
  store?: string;
  /**
   *
   * @type {Date}
   * @memberof ShopForMeItem
   */
  createdAt?: Date;
}

/**
 * Check if a given object implements the ShopForMeItem interface.
 */
export function instanceOfShopForMeItem(
  value: object
): value is ShopForMeItem {
  return true;
}

export function ShopForMeItemFromJSON(json: any): ShopForMeItem {
  return ShopForMeItemFromJSONTyped(json, false);
}

export function ShopForMeItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ShopForMeItem {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    requestId: json['requestId'] == null ? undefined : json['requestId'],
    productUrl: json['productUrl'] == null ? undefined : json['productUrl'],
    productName: json['productName'] == null ? undefined : json['productName'],
    description: json['description'] == null ? undefined : json['description'],
    quantity: json['quantity'] == null ? undefined : json['quantity'],
    estimatedPrice: json['estimatedPrice'] == null ? undefined : json['estimatedPrice'],
    actualPrice: json['actualPrice'] == null ? undefined : json['actualPrice'],
    status: json['status'] == null ? undefined : json['status'],
    imageUrl: json['imageUrl'] == null ? undefined : json['imageUrl'],
    store: json['store'] == null ? undefined : json['store'],
    createdAt: json['createdAt'] == null ? undefined : new Date(json['createdAt']),
  };
}

export function ShopForMeItemToJSON(json: any): ShopForMeItem {
  return ShopForMeItemToJSONTyped(json, false);
}

export function ShopForMeItemToJSONTyped(
  value?: ShopForMeItem | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    requestId: value['requestId'],
    productUrl: value['productUrl'],
    productName: value['productName'],
    description: value['description'],
    quantity: value['quantity'],
    estimatedPrice: value['estimatedPrice'],
    actualPrice: value['actualPrice'],
    status: value['status'],
    imageUrl: value['imageUrl'],
    store: value['store'],
    createdAt: value['createdAt'] == null ? undefined : value['createdAt'].toISOString(),
  };
}
